import { useMemo } from "react";
import { useGetAccountHistoryQuery } from "features/trading/accounts";
import { AccountHistoryRecord, BalanceTypeEnum } from "helpers/types";

const RECENT_LIMIT = 2;

export interface AccountHistoryStatus {
  hasBoth: boolean;
  recentByType: Record<BalanceTypeEnum, AccountHistoryRecord[]>;
  isLoading: boolean;
}

export const useAccountHistoryStatus = (
  accountId: number | null,
  strategyId: number | null,
): AccountHistoryStatus => {
  const { data, isLoading } = useGetAccountHistoryQuery(
    {
      account_id: accountId as number,
      strategy_id: strategyId as number,
      ordering: "-adjustment_date,-created_on",
    },
    { skip: !accountId || !strategyId },
  );

  const history = data ?? [];

  return useMemo(() => {
    const recentByType: Record<BalanceTypeEnum, AccountHistoryRecord[]> = {
      [BalanceTypeEnum.TRADE_AMOUNT]: history
        .filter((record) => record.balance_type === BalanceTypeEnum.TRADE_AMOUNT)
        .slice(0, RECENT_LIMIT),
      [BalanceTypeEnum.PORTFOLIO]: history
        .filter((record) => record.balance_type === BalanceTypeEnum.PORTFOLIO)
        .slice(0, RECENT_LIMIT),
    };

    return {
      hasBoth:
        recentByType[BalanceTypeEnum.TRADE_AMOUNT].length > 0 &&
        recentByType[BalanceTypeEnum.PORTFOLIO].length > 0,
      recentByType,
      isLoading,
    };
  }, [history, isLoading]);
};
